import { render } from "./InputWithLabel.vue?vue&type=template&id=2d3aec82"
import script from "./InputWithLabel.vue?vue&type=script&lang=js"
export * from "./InputWithLabel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__